import { app } from '../../../../app';
import { Controller } from './shared-authenticators.controller';

app.component('companySharingCenterSharedAuthenticators', {
    bindings: {
        accounts: '<',
        publicServicesWithSsoAnd2FA$: '<',
    },
    controller: Controller,
    templateUrl: require('./shared-authenticators.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/shared-authenticators.component.js